var map = {
	"./icon1.jpg": "38b1",
	"./icon2.jpg": "0a94",
	"./icon3.jpg": "caa6",
	"./icon4.jpg": "64cf",
	"./icon5.jpg": "e84e",
	"./icon6.jpg": "b01f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8c40";